const getters = {
    token: state => state.token,
    code: state => state.code
}
export default getters